import BaseListStyle from "../../styles/BaseListStyle";

const AirportStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    checkbox: {
      minWidth: 130,
      margin: "0px 5px"
    },
    airportLineList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    airportLineListEdit: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    airportList: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    airportListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    airportBandList: {
      "& .MuiTable-root": {
        display: "block"
      }
    },
    notamLineEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
    airportRestrictionEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
    airportCostList: {
      "& .MuiTableHead-root": {
        tableLayout: "fixed",
        width: "calc(100% - 20px)",
        display: "table"
      },
      "& .MuiTableHead-root th:first-child": {
        width: "48px",
        minWidth: "48px",
        maxWidth: "48px",
      },
      // "& .MuiTableHead-root th:nth-child(3)": {
      //   maxWidth: "calc(100% - 972px)",
      //   backgroundColor: "#ff0000",
      // },
    },
    airportCostListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "table",
        width: "calc(100% - 20px)"
      },
      // "& .MuiTableRow-root[mode=update]": {
      //   width: "100%",
      //   display: "table"
      // },
      // "& .MuiTableRow-root[mode=add]": {
      //   width: "100%",
      //   display: "table"
      // },
      // "& .MuiTableRow-root.Mui-selected": {
      //   width: "100%",
      //   display: "table"
      // },
      "& .MuiTableRow-head:first-child": {
        width: "44px",
        minWidth: "44px",
        maxWidth: "44px",
      },
    },    
    timeBlock: {
      textAlign: "center",
    },
    header: {
      fontSize: 12,
      fontWeight: 1000,
      paddingBottom: 5
    },
  }
}

export default AirportStyles;
